// extracted by mini-css-extract-plugin
export default {"container":"DisclaimersButton_container__qxngy","button":"DisclaimersButton_button__WSf45"};